export default __webpack_public_path__ + "static/media/dislike_mask2.eaf1d499.svg";